// ABOUTME: Publishes the in-app chat reply/failure notification the app's one
// SSE connection (useEventStream) delivers, so the chat transport hook can
// react to it without opening a second stream connection of its own (#2569
// Part 1). Every reply arrives as an `agent_run_completed` /
// `agent_run_failed` Notification with `payload.channel === "in_app"` — see
// app/services/agent_fleet/dispatcher.py. `agent_run_waiting` says the agent is starting up.

import { create } from 'zustand'

export interface HermesChatReplyEvent {
  /** The Notification id — used to dedupe a re-delivered event. */
  notificationId: string
  /** `waiting`: the agent is starting up; the turns it names stay open. */
  kind: 'reply' | 'failure' | 'waiting'
  /** HermesConversationMessage id (reply) — matches a row `GET
   *  /agent/chat/history` would also return. */
  messageId?: string
  content?: string
  createdAt?: string
  error?: string
  /** The stored messages the run answered (the one it was woken for and any
   *  steered into it while it ran). */
  answers?: string[]
  /** About how long until the agent is up (`waiting`). */
  etaSeconds?: number
}

interface HermesReplyState {
  lastEvent: HermesChatReplyEvent | null
  publish: (event: HermesChatReplyEvent) => void
}

export const useHermesReplyStore = create<HermesReplyState>((set) => ({
  lastEvent: null,
  publish: (event) => set({ lastEvent: event }),
}))
